import SButton from './src/main';

export default SButton;
